import React, { Component, PropTypes } from 'react';
import { GithubPicker } from 'react-color';
import { connect } from 'react-redux';

class WrapColorPicker extends Component {
    state = {
        displayColorPicker: false
    };

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChange = color => {
        this.props.onColorChange({ target: { value: color.hex } });
    };

    render() {
        return (
            <div className={this.props.className} onClick={this.handleClick}>
                {this.props.children}
                {this.state.displayColorPicker ? (
                    <div className="preset-color-picker-popover">
                        <div className="preset-color-picker-cover" onClick={this.handleClose} />
                        <GithubPicker
                            color={this.props.color}
                            onChange={this.handleChange}
                            colors={[
                                this.props.primary.colors[0].color,
                                this.props.primary.colors[1].color,
                                this.props.primary.colors[2].color,
                                this.props.primary.colors[3].color,
                                this.props.primary.colors[4].color,
                                this.props.primary.colors[5].color,
                                this.props.primary.colors[6].color,
                                this.props.primary.colors[7].color,
                                this.props.primary.colors[8].color,
                                this.props.primary.colors[9].color,
                                this.props.primary.colors[10].color,
                                this.props.primary.colors[11].color,
                                this.props.background.colors[0].color,
                                this.props.background.colors[1].color,
                                this.props.background.colors[2].color,
                                this.props.background.colors[3].color
                            ]}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

WrapColorPicker.propTypes = {
    color: PropTypes.string,
    onColorChange: PropTypes.func,
    className: PropTypes.string
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.colors, ...state.theme.colors };
};

export default connect(mapStateToProps)(WrapColorPicker);



// WEBPACK FOOTER //
// ./src/components/widgets/WrapColorPicker.js